import browserHydrateFunction from './src/utils/browserHydrateFunction';
export const replaceHydrateFunction = browserHydrateFunction;